export interface Intervention {
    id: string;
    citizenId: string;
    interventionType: InterventionType;
    cost: number;
    purpose: string;
    notes: string;
    occurredAt: Date;
    createdAt: Date;
    lastModifiedAt: Date;
}

export enum InterventionType {
    "MARTA Card" = "MARTA_CARD",
    "Transportation" = "TRANSPORTATION",
    "Other Documents" = "OTHER_DOCUMENTS",
    "Other Assistance" = "OTHER_ASSISTANCE",
}